const actions = {
  SEARCH_EVENTS: 'SEARCH_EVENTS',
  SEARCH_EVENTS_ENDED: 'SEARCH_EVENTS_ENDED',
  SEARCH_NOTIFICATION_TOOLS: 'SEARCH_NOTIFICATION_TOOLS',
  SEARCH_NOTIFICATION_TOOLS_ENDED: 'SEARCH_NOTIFICATION_TOOLS_ENDED',
  SEARCH_EVENT_ATTRIBUTES: 'SEARCH_EVENT_ATTRIBUTES',
  SEARCH_EVENT_ATTRIBUTES_ENDED: 'SEARCH_EVENT_ATTRIBUTES_ENDED',
  CREATE_EVENT_NOTIFICATION: 'CREATE_EVENT_NOTIFICATION',
  CREATE_EVENT_NOTIFICATION_ENDED: 'CREATE_EVENT_NOTIFICATION_ENDED',
  SEARCH_EVENT_NOTIFICATIONS: 'SEARCH_EVENT_NOTIFICATIONS',
  SEARCH_EVENT_NOTIFICATIONS_ENDED: 'SEARCH_EVENT_NOTIFICATIONS_ENDED',
  FIND_EVENT_NOTIFICATION: 'FIND_EVENT_NOTIFICATION',
  FIND_EVENT_NOTIFICATION_ENDED: 'FIND_EVENT_NOTIFICATION_ENDED',
  UPDATE_EVENT_NOTIFICATION: 'UPDATE_EVENT_NOTIFICATION',
  UPDATE_EVENT_NOTIFICATION_ENDED: 'UPDATE_EVENT_NOTIFICATION_ENDED',
  DELETE_EVENT_NOTIFICATIONS: 'DELETE_EVENT_NOTIFICATIONS',
  DELETE_EVENT_NOTIFICATIONS_ENDED: 'DELETE_EVENT_NOTIFICATIONS_ENDED',
  SEARCH_EVENT_NOTIFICATION_TASKS: 'SEARCH_EVENT_NOTIFICATION_TASKS',
  SEARCH_EVENT_NOTIFICATION_TASKS_ENDED: 'SEARCH_EVENT_NOTIFICATION_TASKS_ENDED',
  SEARCH_BRAND_STORE_ACCOUNT_EVENT_NOTIFICATION_TASKS:
    'SEARCH_BRAND_STORE_ACCOUNT_EVENT_NOTIFICATION_TASKS',
  SEARCH_BRAND_STORE_ACCOUNT_EVENT_NOTIFICATION_TASKS_END:
    'SEARCH_BRAND_STORE_ACCOUNT_EVENT_NOTIFICATION_TASKS_END',
  UNMASK_EVENT_NOTIFICATION_CONTENT: 'UNMASK_EVENT_NOTIFICATION_CONTENT',
  UNMASK_EVENT_NOTIFICATION_CONTENT_ENDED: 'UNMASK_EVENT_NOTIFICATION_CONTENT_ENDED',
  SEARCH_NOTIFICATION_CONFIGURATIONS: 'SEARCH_NOTIFICATION_CONFIGURATIONS',
  SEARCH_NOTIFICATION_CONFIGURATIONS_ENDED: 'SEARCH_NOTIFICATION_CONFIGURATIONS_ENDED',
};

export default actions;
